import {
  Pipe, PipeTransform,
} from '@angular/core'
import { Duration } from 'luxon'

@Pipe({
  name: 'formatDuration',
  standalone: true,
})
export class FormatDurationPipe implements PipeTransform {
  public transform(
    duration: Duration,
    format: string,
    options?: { floor?: boolean | undefined },
  ): string {
    return duration
      .toFormat(format, options)
  }
}
